<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="pl-2 mt-2 f-20-mobile">Copiar Cardápio PDV</h4>
          </div>
          <div class="col-md-6 mb-3">
            <label>Empresa originária dos dados (Buscar por idi ou CNPJ)</label>
              <input type="text" v-model="pesquisa_original" v-debounce:250ms="pesquisaInstalacaoOriginal" class="form-control">
              <div class="mt-2 bold">
                 <div>Idi: {{ empresa_original.idi }}</div>
                 <div>CNPJ: {{ empresa_original.cnpj }}</div>
                 <div>Nome: {{ empresa_original.nome_fantasia }}</div>
              </div>
          </div>
          <div class="col-md-6 mb-3">
            <label>Empresa destinatária dos dados (Buscar por idi ou CNPJ)</label>
              <input type="text" v-model="pesquisa_copia" v-debounce:250ms="pesquisaInstalacaoCopia" class="form-control">
              <div class="mt-2 bold">
                 <div>Idi: {{ empresa_copia.idi }}</div>
                 <div>CNPJ: {{ empresa_copia.cnpj }}</div>
                 <div>Nome: {{ empresa_copia.nome_fantasia }}</div>
              </div>
          </div>

          <div class="col-md-10 my-3 flex-center-div">
            <input type="checkbox" id="checkbox" v-model="checkBoxList.fresh" value="excluir"/>
            <label class="ml-2 mb-0">Excluir os cadastros atuais antes de colocar os novos</label>
          </div>
          <div class="col-md-10 mb-3 flex-center-div">
            <input type="checkbox" id="checkbox" v-model="checkBoxList.produtos" value="excluir"/>
            <label class="ml-2 mb-0">Copiar os produtos do PDV</label>
          </div>
          <div class="col-md-10 mb-3 flex-center-div">
            <input type="checkbox" id="checkbox" v-model="checkBoxList.formas_pagamento" value="excluir"/>
            <label class="ml-2 mb-0">Copiar as formas de pagamento do PDV</label>
          </div>
          <div class="col-md-10 mb-3 flex-center-div">
            <input type="checkbox" id="checkbox" v-model="checkBoxList.cardapio" value="excluir"/>
            <label class="ml-2 mb-0">Copiar os produtos do delivery</label>
          </div>
          <div class="col-md-10 mb-3 flex-center-div">
            <input type="checkbox" id="checkbox" v-model="checkBoxList.cardapio_horario" value="excluir"/>
            <label class="ml-2 mb-0">Copiar os horários de funcionamento do delivery</label>
          </div>
          <div class="col-md-10 mb-3 flex-center-div">
            <input type="checkbox" id="checkbox" v-model="checkBoxList.cardapio_area_entrega" value="excluir"/>
            <label class="ml-2 mb-0">Copiar a área de entrega do delivery</label>
          </div>
          <div class="col-md-10 mb-3 flex-center-div">
            <input type="checkbox" id="checkbox" v-model="checkBoxList.cardapio_formas_pagamento" value="excluir"/>
            <label class="ml-2 mb-0">Copiar as formas de pagamento do delivery</label>
          </div>
          <div class="col-md-10 mb-3 flex-center-div">
            <input type="checkbox" id="checkbox-clientes" v-model="checkBoxList.clientes" value="excluir"/>
            <label class="ml-2 mb-0" for="checkbox-clientes">Copiar os clientes</label>
          </div>


          <div class="py-1 pl-2">
            <button class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary" @click="copiarCardapio()">Copiar Cardápio {{teste}}</button>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment'
import "vue-select/dist/vue-select.css";
import loadApp from '@/services/InstalacaoService.js'


export default {
    components: {
      moment
    },
    data() {
      return {
        checked: false,
        switch1: true,
        success:false,
        fail:false,
        idi:null,
        pesquisa_original:'',
        pesquisa_copia:'',
        empresa_original: {},
        empresa_copia: {},
        instalacoes: [],
        mensagem_erro:null,
        checkBoxList: {
          fresh:false,
          produtos:false,
          formas_pagamento:false,
          cardapio:false,
          cardapio_horario:false,
          cardapio_area_entrega:false,
          cardapio_formas_pagamento:false,
          clientes:false,
        },
      }
    },
    methods:{
      copiarCardapio(){
        this.$swal({
          title: "Atenção",
          html: "Tem certeza que deseja Continuar?</p>",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#afafaf",
          confirmButtonText: "Sim, alterar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.value) {
            let params = {
              "copy_secret":'',//preenchido no back
              "from": this.empresa_original.idi,
              "from_cnpj": this.empresa_original.cnpj,
              "to": this.empresa_copia.idi, 
              "to_cnpj": this.empresa_copia.cnpj,
              "fresh": this.checkBoxList.fresh,
              "produtos": this.checkBoxList.produtos,
              "formas_pagamento": this.checkBoxList.formas_pagamento,
              "cardapio": this.checkBoxList.cardapio,
              "cardapio_horario": this.checkBoxList.horario,
              "cardapio_area_entrega": this.checkBoxList.area_entrega,
              "cardapio_formas_pagamento": this.checkBoxList.cardapio_formas_pagamento,
              "clientes": this.checkBoxList.clientes,
            }

            loadApp.copyApp(params).then(res =>{
              this.$swal({
                title:"Sucesso!",
                icon:"success",
                text:"App copiado!"
              })
            }).catch(err => {
              this.$swal({
                title:"Erro",
                icon:"warning",
              })
            })

          }
        });
      },
      pesquisaInstalacaoOriginal(){
        loadApp.loadApp(this.pesquisa_original).then(res => {
          this.empresa_original = res.data[0]
          if(!this.empresa_original){
            this.empresa_original = {idi:null,cnpj:"Nenhuma Empresa Encontrada",nome_fantasia:"Nenhuma Empresa Encontrada"}
          }
          this.$forceUpdate()
        }).catch(err => {
          console.error(err)
        })
      },
      pesquisaInstalacaoCopia(){
        loadApp.loadApp(this.pesquisa_copia).then(res => {
          this.empresa_copia = res.data[0]
          if(!this.empresa_copia){
            this.empresa_copia = {idi:null,cnpj:"Nenhuma Empresa Encontrada",nome_fantasia:"Nenhuma Empresa Encontrada"}
          }
          this.$forceUpdate()
        }).catch(err => {
          console.error(err)
        })
      }
    }
}
</script>

<style>
  .flex-center-div {
    display: flex;
    align-items: center;
  }
</style>
